import { type Locale } from './language'

/**
 * Gets Shopify cart ID local storage key.
 */
export const getShopifyCartIdStorageKey = (locale: Locale) =>
  `cart_id_${locale}_v2`
